var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13830_61101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.32001 1.5H18.68V22.5H5.32001V1.5Z",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17999 5.31982H10.09",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17999 9.14014H10.09",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17999 12.9502H10.09",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.05 5.31982H12.95",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.05 9.14014H12.95",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.05 12.9502H12.95",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.91 5.31982H15.82",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.91 9.14014H15.82",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.91 12.9502H15.82",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14001 17.73H14.87V22.5H9.14001V17.73Z",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32 22.5H1.5V13.91L5.32 12V22.5Z",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.68 22.5H22.5V13.91L18.68 12V22.5Z",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13830_61101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.d372680f.svg";
export { ForwardRef as ReactComponent };